import React from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import includes from 'lodash/includes';

import * as analytics from '@eb/site-analytics';
import { collections as collectionsDuck } from '@eb/destination-utils';

import { trackLocationChange as trackLocationChangeAction } from '../actions/location';
import { trackEventClickInternal as trackEventClickInternalAction } from '../actions/analytics';
import { saveEvent as saveEventAction } from '../actions/event';
import { getBucketContent, getBrowseSection } from '../utils';
import { logCheckpointEidOnPageChange } from '../utils/janus';
import { getOrganizersFromEvents } from '../selectors/organizers';

import {
    GA_CITY_BROWSE_CATEGORY,
    NON_MANUAL_SOURCES,
    CITY_BROWSE_EVENT_CLICKED,
    CITY_BROWSE_MANUAL_EVENT_CLICKED,
} from '../constants';

const StyledBucket = loadable(() =>
    import('../components/styledBucket/StyledBucket'),
);

const {
    actions: {
        addOrRemoveEventToCollection: addOrRemoveEventToCollectionAction,
        createCollection: createCollectionAction,
    },
    selectors: { getFormattedCollections },
} = collectionsDuck;

const { trackEventFromState, trackEventFromStateOnPageUnload } = analytics;

export class BrowseBucket extends React.Component {
    _handleOnSaveEvent = (eventId, shouldSave) => {
        const { onSaveEvent } = this.props;

        return onSaveEvent(eventId, shouldSave, true);
    };

    _handleTrackEventClickInternal = (data, ticketsBy) => {
        const { domain, trackEventClickInternal } = this.props;

        const janusCheckpoint = includes(NON_MANUAL_SOURCES, ticketsBy)
            ? CITY_BROWSE_EVENT_CLICKED
            : CITY_BROWSE_MANUAL_EVENT_CLICKED;

        logCheckpointEidOnPageChange(janusCheckpoint, domain, data.itemId);
        trackEventClickInternal(data);
    };

    render() {
        return (
            <StyledBucket
                {...this.props}
                onSaveEvent={this._handleOnSaveEvent}
                onTrackEventClickInternal={this._handleTrackEventClickInternal}
            />
        );
    }
}

export const _mapStateToProps = (state, ownProps) => {
    const {
        bucketConfig,
        containerClasses,
        bucketWrapperClasses,
        decorationPlacement,
        decorativeImage,
    } = ownProps;

    const section = getBrowseSection(state.location.isOnline);
    const content = getBucketContent(
        state.content,
        bucketConfig,
        state.currencyFormat,
        section,
    );
    const organizers =
        bucketConfig.type === 'follow_organizer'
            ? getOrganizersFromEvents(state)
            : undefined;

    return {
        content,
        containerClasses,
        bucketWrapperClasses,
        decorationPlacement,
        decorativeImage,
        organizers,
        userCollections: getFormattedCollections(state),
        currentPlace: state.location.currentPlace,
        currentPlaceParent: state.location.currentPlaceParent,
        placeType: state.location.placeType,
        isAuthenticated: state.auth.isAuthenticated,
        shareOptions: state.share.options,
        allEventsUrl: state.content.allEventsUrl,
        httpReferer: state.app.httpReferer,
        locationSlug: state.location.slug,
        domain: state.app.domain,
        featureFlags: state.app.featureFlags,
        experiments: state.app.experiments,
        userEmail: state.app.userEmail,
        publicId: state.app.publicId,
        userId: state.app.publicId,
        isBotRequest: state.app.isBotRequest,
        isGDPRCountry: state.app.isGDPRCountry,
        gaCategory: GA_CITY_BROWSE_CATEGORY,
        gaActionSuffix: 'CityBrowse',
        gaSettings: state.app.gaSettings,
        bucketKey: bucketConfig.key,
        trackGAEvent: (action) =>
            trackEventFromState(state, {
                category: GA_CITY_BROWSE_CATEGORY,
                ...action,
            }),
        trackGAEventOnPageUnload: (action) =>
            trackEventFromStateOnPageUnload(state, {
                category: GA_CITY_BROWSE_CATEGORY,
                ...action,
            }),
        ...bucketConfig,
    };
};

const _mapDispatchToProps = (dispatch) => ({
    onSaveEvent: (...args) => dispatch(saveEventAction(...args)),
    trackLocationChange: (...args) =>
        dispatch(trackLocationChangeAction(...args)),
    onAddOrRemoveEventToCollection: (...args) =>
        dispatch(
            addOrRemoveEventToCollectionAction(GA_CITY_BROWSE_CATEGORY)(
                ...args,
            ),
        ),
    onCreateCollection: (...args) =>
        dispatch(createCollectionAction(GA_CITY_BROWSE_CATEGORY)(...args)),
    trackEventClickInternal: (...args) =>
        dispatch(trackEventClickInternalAction(...args)),
});

export default connect(_mapStateToProps, _mapDispatchToProps)(BrowseBucket);
